<template>
  <div>
     <!-- 回复内容表单 -->
      <el-form ref="ReplyForm" :model="ReplyForm" style="margin-top:10px;margin-bottom:60px;" :rules="ReplyRules">
        
        <!-- <div class="el-row-qfsBox"></div>
        <div class="el-row-line"></div>
        <div class="el-row-qlsBox"></div> -->

        <el-row type="flex" class="row-bg">
          <el-col :span="7">
              <el-form-item label="访客昵称" prop="user_nickname" label-width="120px">
                <el-input style="width:16em" v-model="ReplyForm.user_nickname" readonly></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="7">
              <el-form-item label="联系方式" prop="s_contact" label-width="120px">
                <el-input style="width:16em" v-model="ReplyForm.s_contact" readonly></el-input>
              </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg">
            <el-col :span="7">
              <el-form-item label="反馈时间" prop="s_createtime" label-width="120px">
                <el-date-picker
                  type="datetime"
                  value-format="timestamp"
                  v-model="ReplyForm.s_createtime"
                  style="width:16em"
                  placeholder="反馈时间"
                  readonly>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="7"> 
              <el-form-item label="反馈类型" prop="s_type" label-width="120px">
                  <el-select v-model="ReplyForm.s_type" placeholder="反馈类型" style="width:16em" auto-complete="off" disabled>
                      <el-option v-for="item in searchTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
        </el-row>


        <el-row type="flex" class="row-bg">
            <el-col :span="14">
                <el-form-item label="反馈内容" prop="s_content" label-width="120px">
                    <el-input type="textarea" :rows="4" style="width:100%" v-model="ReplyForm.s_content" readonly>
                    </el-input>
                </el-form-item>
            </el-col>
        </el-row>

        <!-- <el-row type="flex" class="row-bg">
            <el-col :span="14">
                <el-form-item label="图片" prop="s_img" label-width="120px">
                  <el-upload
                      disabled
                      :class="{disabled:uploadDisabled}"
                      :limit="10"
                      :action="ReplyUploadUrl "
                      list-type="picture-card"
                      :on-preview="handleReplyPreview"
                      :file-list="ReplyUploadFileList">
                      <i class="el-icon-plus"></i>
                  </el-upload>
                  <p style="margin:0;color:#41b883;font-size:12px;">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
                  <el-dialog :visible.sync="ReplyPreviewDialogVisible">
                      <img width="100%" :src="ReplyPreviewDialogImageUrl" alt="">
                  </el-dialog>
                </el-form-item>
            </el-col>
        </el-row> -->




        <el-row type="flex" class="row-bg">
          <el-col :span="14">
              <el-form-item label="回复内容" prop="s_reply" label-width="120px">
                  <el-input type="textarea" :rows="4" style="width:100%" v-model="ReplyForm.s_reply" maxlength="400">
                  </el-input>
                  <span style="color:red">* 最多可输入400个字</span>
              </el-form-item>
          </el-col>
        </el-row>

        <el-footer>
          <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
          <el-button type="primary" @click="submitReplyForm('ReplyForm')" size="small" icon="el-icon-edit-outline">回复</el-button>
        </el-footer>
      </el-form>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

// 时间过滤器
import {formatDate} from '@/filter/date.js';
export default {
  name: 'objectionReply',
  data() {
      return {
          ReplyForm:{
            s_id:'',
          },
          ReplyUploadUrl : `${api.dev}/p/suggestion/objection/uploadFile?access_token=${getToken()}`, // 上传图片路径
          ReplyUploadFileList : [],
          ReplyPreviewDialogVisible : false,
          ReplyPreviewDialogImageUrl : '',
          ReplyRules : {
              s_reply : [{required: true,message : '请输入回复内容', trigger: 'blur'}],
          },

          searchTypeList : [
            {
              value: '1',
              label: '稿文申诉'
            },{
              value: '2',
              label: '作品申诉'
            },{
              value: '3',
              label: '意见建议'
            },{
              value: '4',
              label: '文章纠错'
            },{
              value: '5',
              label: '内容纠错'
            }
          ],
          value: '',

      }
  },
  methods : {
    getInfo() {
          this.$http.get(`${api.dev}/p/main/suggestion/select`,{params : {access_token : getToken(), s_id : this.$route.params.id}}).then(res => {
            if(res.body.code == 200) {

              this.ReplyForm = res.body.content;
              this.ReplyForm.s_id = res.body.content.s_id;
              if(res.body.content.user_nickname == undefined){
                this.ReplyForm.user_nickname = "匿名";
                this.ReplyForm.s_contact = res.body.content.s_contact;
              }else{
                this.ReplyForm.user_nickname = res.body.content.user_nickname;
                this.ReplyForm.s_contact = res.body.content.user_phone;
              }
              res.body.content.s_createtime = (res.body.content.s_createtime) ? res.body.content.s_createtime : '';
              
              // if(res.body.content.s_type == "1"){
              //   res.body.content.s_type = "稿文申诉";
              // }else if(res.body.content.s_type == "2"){
              //   res.body.content.s_type = "作品申诉";
              // }else if(res.body.content.s_type == "3"){
              //   res.body.content.s_type = "意见建议";
              // }else if(res.body.content.s_type == "4"){
              //   res.body.content.s_type = "文章纠错";
              // }else if(res.body.content.s_type == "5"){
              //   res.body.content.s_type = "内容纠错";
              // }
              this.ReplyForm.s_type = res.body.content.s_type;
              this.ReplyForm.s_content = res.body.content.s_content;
              if(this.ReplyForm.s_img.length > 0){
                for(var i=0;i<this.ReplyForm.s_img.length;i++){
                  this.ReplyUploadFileList.push({url : `${api.address}${this.ReplyForm.s_img[i]}`})
                }
              }
              this.ReplyForm.s_content = res.body.content.s_content;
            }else if(res.body.code == 500) {
              this.$message({
                message: res.body.msg,
                type: 'error'
              });
              removeToken();
              setTimeout(function () {
                this.$router.push({path: '/login'});
              },2000)
            }
          })

    },



    // 放大图片
    handleReplyPreview(file) {
        this.ReplyPreviewDialogVisible = true;
        this.ReplyPreviewDialogImageUrl  = file.url;
    },

    // 返回
    goBack() {
        this.$router.back(-1);
    },
    submitReplyForm(formName){
      this.$refs[formName].validate((valid) => {
        if(valid) {
            // 开启加载器
            const loading = this.$loading({
                lock: true,
                text: '正在保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var formdata = new FormData();
            formdata.append('access_token',getToken());
            formdata.append('s_id',this.ReplyForm.s_id);
            formdata.append('s_reply',this.ReplyForm.s_reply);
            this.$http.post(`${api.dev}/p/main/suggestion/reply`,formdata,{emulateJSON: true}).then(res => {
              if(res.body.code == 200) {
                    loading.close();
                    // this.$refs[formName].clearValidate(); // 清除表单验证规则
                    this.$message({
                        message: res.body.msg,
                        type: 'success'
                    });
                    // this.loading = true;
                    // this.getInfo();
                    this.$router.back(-1);
              }else if(res.body.code == 500) {
                loading.close();
                this.$message({
                    message : res.body.msg,
                    type : 'error'
                })
              }
            })
        }else {
          console.log('error submit');
          return false;
        }
      })
    },

  },
  created() {
    this.getInfo();
  },
  computed: {
      uploadDisabled:function() {
          return this.ReplyForm.s_img != '' && this.ReplyForm.s_img != null
      },
  },
}
</script>

<style lang="stylus" scoped>
.margin-bottom-10
  margin-bottom 10px
.padding-right-12
  padding-right 12px
/*.el-row-qfsBox
  padding-top: 40px;
  background-color:#fcf3ee;
  border: 1px dashed #810007;
.el-row-line
  margin:10px 0;
  width:100%;
  height:1px;
  background-color:#ccc;
.el-row-qlsBox
  padding-top: 25px;
  background-color:#f1f9ee;
  border: 1px dashed #0b512f;*/
.el-footer
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999;
    margin-left -15px;


</style>
